export default __webpack_public_path__ + "static/media/img_fail.8259f30f.png";